import React from 'react'
import Navbar from '../navbar'
import Footer from '../Footer'
import ContactUs from '../ContactUs'

const Contact = () => {
    return (
        <>
            <Navbar />

            <ContactUs />

            <Footer />
        </>
    )
}

export default Contact